import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import debounce from "lodash.debounce";
import { fetchMembersView, fetchMemberDetailsByHccId, fetchProviderNetworks, fetchMemberBySystemIdentifier, fetchMemberByMemberUuid, fetchAccumulatorDetails, fetchPayeeBankAccountsFromDB } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import Select from 'react-select';
import { AsyncPaginate } from "react-select-async-paginate";
import ReactJson from "react-json-view";
import { loadAccountHccIdentificationNumber, loadAccounts } from "../../utils/optionLoaderUtils";
import { customStyles } from "../../utils/styleUtils";
import { useNavigate } from "react-router";

const limit = 20;

const searchOptions = [
    { value: 'accountNumber', label: 'Bank account Number' },
    { value: 'accountName', label: 'Bank account Name' },
    { value: 'bankName', label: 'Bank Name' },

    { value: 'payeeBankAcctsFactKey', label: 'Payee Bank Accts FactKey' },
    { value: 'subscriptionKey', label: 'Subscription Key' },
    { value: 'brokerKey', label: 'Broker Key' },
    { value: 'supplierLocationKey', label: 'Supplier LocationKey' },
    { value: 'supplierKey', label: 'Supplier Key' },
]

const PayeeBankAccounts = () => {
    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();

    const [searchBy, setSearchBy] = useState(null);
    const [selectedAccounts, setSelectedAccounts] = useState([null])


    const [showMoreColumns, setShowMoreColumns] = useState(false);

    const { ref, inView } = useInView();

    const { data, error, fetchNextPage, hasNextPage, isLoading, isPending, isFetching, isFetchingNextPage, status, refetch } = useInfiniteQuery({
        queryKey: ["payee-bank-accounts", limit, decouncedSearchValue, selectedAccounts],
        queryFn: async ({ pageParam }) => {
            let params = pageParam || {};

            if (decouncedSearchValue && searchBy?.value) {
                params[searchBy?.value] = decouncedSearchValue;
            }

            return await fetchPayeeBankAccountsFromDB({
                ...params,
                limit,
                //    acctIdKey: selectedAccounts?.filter(f => f).at(-1)?.additional?.accountKey
            });
        },

        select: (data) => {
            // console.log({ data });
            return { count: data.pages?.[0]?.count, rows: data.pages.map((page) => page.rows).flatMap((x) => x) };
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => {
            const hasMore = lastPage?.rows?.length === limit;

            if (!hasMore) return undefined;
            return {
                offset: pages.reduce((accum, page) => {
                    return accum + page.rows.length;
                }, 0),
            };
        },
        staleTime: 0,
        enabled: true
    });

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    let columns = ['payeeBankAcctsFactKey', 'supplierKey', 'supplierLocationKey', 'brokerKey', 'subscriptionKey', 'accountNumber', 'bankName', 'routingNumber', 'startDateKey', 'endDateKey'];

    if (showMoreColumns) {
        columns = [
            'payeeBankAcctsFactKey',
            'payeeBankAcctDateRgFKey',
            ...columns,

            'bankAcctType',
            'country'

        ];
    }

    return (
        <div className={'container '}>
            <p className='title'>Payee Bank accounts ( {data?.count || 0} )</p>
            <p className="sub-title">Bank accounts by Payee</p>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>

                    {/* {selectedAccounts?.map((account, i) => {
                        return <AsyncPaginate
                            key={i}
                            placeholder={`Select ${i ? ' sub account' : 'an account'}`}
                            className="react-select-container large-input"
                            classNamePrefix={"react-select"}
                            debounceTimeout={300}
                            value={selectedAccounts[i]}
                            //  cacheUniqs={[i]}
                            clearCacheOnMenuClose={true}
                            clearCacheOnSearchChange={true}
                            isSearchable={true}
                            loadOptions={loadAccounts} //{i ? loadAccounts : loadAccountHccIdentificationNumber}
                            onChange={v => {
                                let newArray
                                if (!v) {
                                    if (!i) {
                                        newArray = [null]
                                    } else {
                                        newArray = [...selectedAccounts.slice(0, i), null]
                                    }
                                }

                                else {
                                    if (!i) {
                                        newArray = [v];
                                        if (v?.additional?.subAccountsCount) {
                                            newArray.push(null)
                                        }
                                    } else {
                                        newArray = [
                                            ...selectedAccounts.slice(0, i),
                                            v,
                                            ...selectedAccounts.slice(i)
                                        ];
                                        if (!v?.additional?.subAccountsCount) {
                                            newArray.splice(newArray.length - 1, 1)
                                        }

                                    }
                                }
                                setSelectedAccounts(newArray)
                            }}

                            styles={customStyles}
                            isClearable={true}
                            additional={{
                                includeSubAccounts: 'Y',
                                accountLevel: (selectedAccounts?.[i - 1]?.additional?.accountLevel || 0) + i ? 1 : 0,
                                parentAccountKey: selectedAccounts?.[i - 1]?.additional?.parentAccountKey
                            }}
                        />
                    })} */}

                    <Select
                        name={'searchBy'}
                        className="react-select-container large-input"
                        classNamePrefix="react-select"
                        placeholder={'Search by'}
                        // inputRef={field.ref}
                        options={searchOptions}
                        value={searchBy}
                        onChange={(option) => { setSearchBy(option) }}
                    />

                    {searchBy && <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"search"}
                        placeholder="search..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />}

                </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem" }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {
                        setSearchBy(null)
                        setDecouncedSearchValue("");
                        setSearchValue("");
                        setSelectedAccounts([null])
                    }}
                >
                    Clear filters
                </p>

                <p style={{ cursor: "pointer", color: "var(--green)" }} onClick={() => setShowMoreColumns(!showMoreColumns)}>
                    {showMoreColumns ? "Less Columns" : "More Columns"}
                </p>

            </div>


            {
                status === "loading" ? (
                    <p>Loading...</p>
                ) : status === "error" ? (
                    <span className='danger'>Error: {error.message}</span>
                ) : (
                    <>
                        <SharedTable
                            type={"bank-accounts"}
                            columns={columns}
                            items={data?.rows}
                            activeDraftId={null}
                            hasNextPage={hasNextPage}
                            isFetchingNextPage={isFetchingNextPage}
                            fetchNextPage={fetchNextPage}
                            isFetching={isFetching}
                            isLoading={isLoading}
                            // onEditHandler={onEditHandler}
                            //   onDetailHandler={onDetailHandler}
                            disableModel={false}
                            // onDetailHandler={async (body) => {
                            //     //body?.memberHccId && window.open(`/members/${body?.memberHccId}`, '_blank', 'noopener,noreferrer')
                            //     return body
                            // }}
                            ref={ref}
                        />
                    </>
                )
            }

        </div >
    )
}


export default PayeeBankAccounts